(function () {
  'use strict';

  /**
   * MOXIE — WCAG 2.1.1 / 2.4.3 — Sizebay VFR focus management
   *
   * LIMITATION (cross-origin iframe):
   *   #szb-container lives inside Sizebay's iframe document, not in the main
   *   page document. Theme JS cannot access or focus elements inside a
   *   cross-origin iframe. The ONLY thing achievable from the theme layer is
   *   focusing the <iframe> element itself, so Tab navigation enters the VFR
   *   without requiring a mouse click.
   *
   *   Full focus trap (Tab/Shift+Tab loop) and Escape handling from inside the
   *   iframe are NOT possible from the theme. Sizebay must fix those in their
   *   own application code.
   */

  // MOXIE: el contenedor real que Sizebay inyecta es #szb-container / .vfr__container
  // (ver el segundo IIFE de este archivo) — '#sizebay-container' no existe en la página
  // renderizada, así que este listener nunca disparaba. Corregido para que el manejo de
  // foco funcione de verdad.
  var TRIGGER_SELECTOR = '#szb-container, .vfr__container';
  var trigger  = null;
  var polling  = false;

  function isVisible(el) {
    if (!el || el.hidden) return false;
    var cs = getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden';
  }

  // Find the Sizebay iframe in the main document
  function findSzbIframe() {
    var frames = document.querySelectorAll('iframe');
    for (var i = 0; i < frames.length; i++) {
      var f   = frames[i];
      var src = f.src || f.getAttribute('src') || '';
      var id  = f.id  || '';
      var cls = typeof f.className === 'string' ? f.className : '';
      if (src.indexOf('sizebay') !== -1 ||
          id.indexOf('szb')      !== -1 ||
          cls.indexOf('szb')     !== -1) {
        if (isVisible(f)) return f;
      }
    }
    return null;
  }

  function focusIframe(iframe) {
    // Add ARIA wrapper to the nearest overlay ancestor in the main document
    var wrapper = iframe.parentElement;
    while (wrapper && wrapper !== document.body) {
      var cs = getComputedStyle(wrapper);
      if (cs.position === 'fixed' || cs.position === 'absolute') break;
      wrapper = wrapper.parentElement;
    }
    if (wrapper && wrapper !== document.body) {
      if (!wrapper.hasAttribute('role'))       wrapper.setAttribute('role', 'dialog');
      if (!wrapper.hasAttribute('aria-modal')) wrapper.setAttribute('aria-modal', 'true');
      if (!wrapper.hasAttribute('aria-label')) wrapper.setAttribute('aria-label', 'Virtual Fitting Room');
    }

    // Focus the iframe element — browser moves keyboard context into iframe content
    setTimeout(function () {
      iframe.focus();
      if (trigger) {
        // Restore trigger focus when iframe loses focus (user closes VFR)
        iframe.addEventListener('blur', function onBlur() {
          iframe.removeEventListener('blur', onBlur);
          if (trigger) { trigger.focus(); trigger = null; }
        });
      }
    }, 150);
  }

  document.addEventListener('click', function (e) {
    var container = document.querySelector(TRIGGER_SELECTOR);
    if (!container || !container.contains(e.target)) return;

    trigger = e.target.closest('button, a, [role="button"]') || e.target;

    if (polling) return;
    polling = true;
    var attempts = 0;

    function poll() {
      if (!polling || attempts++ > 60) { polling = false; return; }
      var iframe = findSzbIframe();
      if (iframe) {
        polling = false;
        focusIframe(iframe);
        return;
      }
      requestAnimationFrame(poll);
    }

    requestAnimationFrame(poll);
  }, true);

})();

(function () {
  'use strict';

  /**
   * MOXIE [Ticket 86e1cfrdr - punto 3] — Sizebay loading placeholder on the PDP.
   *
   * Sizebay's own script inserts its widget (#szb-container / .vfr__container)
   * directly as a child of .hdt-product-info__list, between the variant picker
   * and the buy button — it does not use any placeholder element we provide,
   * so this observes that real container instead.
   *
   * .hdt-product-info__list is shared by quick-view/quick-buy/group-product
   * (blocks/_group-product.liquid), so this only targets the actual PDP
   * instance via the `hdt-secion-main-product--` wrapper class that only
   * sections/main-product.liquid renders (PDP-only, per component-strategy-rules.md).
   *
   * WCAG 4.1.2: role="status" + aria-live="polite" + an accessible name
   * (sourced from the translated #sizebay-loading-sr-text span rendered by
   * sections/main-product.liquid) are on the placeholder itself.
   */

  var PDP_LIST_SELECTOR = '[class*="hdt-secion-main-product--"] .hdt-product-info__list';
  var SIZEBAY_WIDGET_SELECTOR = '#szb-container, .vfr__container';
  var SHOW_DELAY_MS = 250; // brief, not instantaneous — avoids a flash on fast loads
  var MAX_WAIT_MS = 15000; // don't spin forever if Sizebay never responds (or never applies)

  function buildPlaceholder() {
    var srText = document.getElementById('sizebay-loading-sr-text');
    var el = document.createElement('div');
    el.className = 'hdt-sizebay-loading';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<svg width="20" height="20" class="hdt-sizebay-loading__spinner" focusable="false" aria-hidden="true" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="hdt-path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>' +
      // MOXIE [Ticket 86e1cfrdr - punto 3, nota de revisión]: el texto ahora es visible
      // en pantalla (antes sr-only) — además de servir como nombre accesible del status.
      '<span class="hdt-sizebay-loading__text">' + (srText ? srText.textContent : 'Loading size options') + '</span>';
    return el;
  }

  function initList(list) {
    if (!list || list.dataset.sizebaySpinnerInit) return;
    if (list.querySelector(SIZEBAY_WIDGET_SELECTOR)) return; // already loaded
    list.dataset.sizebaySpinnerInit = '1';

    var anchor = list.querySelector('.hdt-product__buy-button');
    var placeholder = buildPlaceholder();
    if (anchor) {
      list.insertBefore(placeholder, anchor);
    } else {
      list.appendChild(placeholder);
    }

    var showTimer = setTimeout(function () {
      placeholder.classList.add('is-visible');
    }, SHOW_DELAY_MS);

    var giveUpTimer;

    function settle() {
      clearTimeout(showTimer);
      clearTimeout(giveUpTimer);
      observer.disconnect();
      if (placeholder.parentNode) placeholder.parentNode.removeChild(placeholder);
    }

    var observer = new MutationObserver(function () {
      if (list.querySelector(SIZEBAY_WIDGET_SELECTOR)) settle();
    });
    observer.observe(list, { childList: true });

    giveUpTimer = setTimeout(settle, MAX_WAIT_MS);
  }

  function init(root) {
    (root || document).querySelectorAll(PDP_LIST_SELECTOR).forEach(initList);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Re-init on section re-renders (theme editor, etc.) that reset the PDP block.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();

(function () {
  'use strict';

  /**
   * MOXIE: block Sizebay's own auto-open of the Virtual Fitting Room on PDP load.
   *
   * Root cause, confirmed by reading the tenant's own prescript.js (hosted at
   * static.sizebay.technology/2952/prescript.js — external, not part of this repo):
   *
   *   setTimeout(() => { document.querySelector('#szb-vfr-button').click() }, 3000)
   *
   * That line unconditionally simulates a click on the VFR trigger 3s after any
   * product page load — there's no setting on our side to turn it off, and we can't
   * edit that external file. But a script-triggered .click() dispatches an event with
   * isTrusted === false, which a real mouse click or keyboard activation never has.
   * So instead of guessing at the modal's markup, this stops the fake click itself,
   * in the capture phase, before Sizebay's own listener on that button ever runs.
   * Genuine (isTrusted) clicks on the same button are left completely untouched —
   * this only ever cancels synthetic ones.
   */
  document.addEventListener('click', function (e) {
    if (e.isTrusted) return;
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('#szb-vfr-button, #szb-measurements-button')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);
})();
